import { Injectable } from '@angular/core';
import { Mapper } from '../mapper/mapper';
import { BaseAPI } from './base-api';
import { ApplicationType, Constants, LookupsType } from '../../common';
import { Observable, map } from 'rxjs';
import { BasicUser, Category, LookupModel } from '../model';
import { Program } from '../model/program-model';
import { InsolventsQueryRequestForm, StudentsQuerySendMessageForm } from 'src/app/shared/interfaces';
import { EjazaModel } from '../model/ejaza-model';
import { planLearningObjectives } from '../model/learning-objectives';
import { SessionSlotsModel } from '../model/session-slots-model';
import { getCustomHeaders } from 'src/app/shared/helper';

@Injectable({
  providedIn: 'root',
})
export class LookUpsApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getCategories(pageIndex: number, pageSize: number): Observable<Category[]> {
    const body = { pageIndex, pageSize };
    return this.baseAPI.post(Constants.GET_CATEGORIES_API_URL, body).pipe(
      map((res) => {
        return this.mapper.fromListJson(Category, res.data); // res : has array of data
      })
    );
  }

  getPrograms(pageIndex: number, pageSize: number): Observable<Program[]> {
    const body = { pageIndex, pageSize };
    return this.baseAPI.post(Constants.GET_DEPENDENTS_MANAGERS_API_URL, body).pipe(
      map((res) => {
        return this.mapper.fromListJson(Program, res.students); // res : has array of students
      })
    );
  }

  getLookUps(type: LookupsType): Observable<LookupModel[]> {
    return this.baseAPI
      .post(Constants.GET_LOOK_UPS_API_URL, { type: type })
      .pipe(map((res) => this.mapper.fromListJson(LookupModel, res.items)));
  }

  getStudentsQuery(form: StudentsQuerySendMessageForm, appName?: ApplicationType): Observable<BasicUser[]> {
    return this.baseAPI
      .post(
        Constants.GET_STUDENTS_QUERY_API_URL,
        form
        // getCustomHeaders(this.baseAPI.getHeaders(), { 'App-Type': appName })
      )
      .pipe(map((res) => this.mapper.fromListJson(BasicUser, res.students)));
  }

  getTeachersQuery(fullName: string): Observable<BasicUser[]> {
    return this.baseAPI
      .post(Constants.GET_TEACHERS_QUERY_API_URL, { fullName })
      .pipe(map((res) => this.mapper.fromListJson(BasicUser, res.teachers)));
  }

  getInsolventsQuery(form: InsolventsQueryRequestForm): Observable<BasicUser[]> {
    return this.baseAPI
      .post(Constants.GET_INSOLVENTS_QUERY_API_URL, form)
      .pipe(map((res) => this.mapper.fromListJson(BasicUser, res.data)));
  }

  getTeacherEjazat(): Observable<EjazaModel[]> {
    return this.baseAPI
      .post(Constants.GET_ALL_EJAZAT_API_URL, { searchText: '' })
      .pipe(map((res) => this.mapper.fromListJson(EjazaModel, res.items)));
  }

  getLearningObjective(): Observable<planLearningObjectives[]> {
    return this.baseAPI.get(Constants.GET_LEARNING_OBJECTIVES_API_URL).pipe(
      map((res) => {
        const initiation = this.mapper.fromListJson(planLearningObjectives, res.initiation);
        const recitationCorrection = this.mapper.fromListJson(planLearningObjectives, res.recitationCorrection);
        const revisionOrMemorizingAndAffirming = this.mapper.fromListJson(
          planLearningObjectives,
          res.revisionOrMemorizingAndAffirming
        );
        const readAndEjaza = this.mapper.fromListJson(planLearningObjectives, res.readAndEjaza);
        return [...initiation, ...recitationCorrection, ...revisionOrMemorizingAndAffirming, ...readAndEjaza];
      })
    );
  }

  getSessionSlots(): Observable<SessionSlotsModel[]> {
    return this.baseAPI
      .get(Constants.GET_SESSION_SLOTS_LOOKUPS_API_URL)
      .pipe(map((res) => this.mapper.fromListJson(SessionSlotsModel, res.slots)));
  }

  getApplicationCategories(applicationTypes: ApplicationType[]): Observable<Category[]> {
    return this.baseAPI.post(Constants.GET_CATEGORIES_API_URL, { applicationTypes }).pipe(
      map((res) => {
        return this.mapper.fromListJson(Category, res.data);
      })
    );
  }
}
